import miniaNoreya from "../assets/images/Miniatures/minia-noreya.png";
import miniaLocked from "../assets/images/Miniatures/minia-locked.png";
import miniaJsnap from "../assets/images/Miniatures/minia-jsnap.png";
import miniaBatcave from "../assets/images/Miniatures/minia-batcave.png";

const prosData = [
    { slug: "noreya", image: miniaNoreya, texte: "Noreya: The Gold Project", sousTexte: "2D Metroidvania - Dreamirl" },
    { slug: "locked", image: miniaLocked, texte: "Locked in a Room", sousTexte: "VR Escape Game - Dreamirl" },
    { slug: "jsnap", image: miniaJsnap, texte: "Jurassic Snap", sousTexte: "Educational VR Game - Dreamirl" },
    { slug: "batcave", image: miniaBatcave, texte: "Cave XR & Barney", sousTexte: "VR Physics Simulation - INSA" }
];

export default prosData;